export default "__VITE_ASSET__LIkA4chT__"